// extracted by mini-css-extract-plugin
export default {"link":"SocialLink_link__g1ufW","img":"SocialLink_img__0RvHx"};